

/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：路由守卫服务
 * 更新记录:
 */
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, DetachedRouteHandle } from '@angular/router';
import { SwSimpleReuseStrategy } from './sw-simplereusestrategy';
import { Subject } from 'rxjs';
import { SwJwtService } from './sw-jwt.service';
import { SwMassageBoxService } from './sw-massage-box.service';
import { SwLoadingmaskService } from 'src/app/librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from './sw-http-client.service';

@Injectable()
export class SwRouteguardService implements CanActivate {

  menuList: Array<{ path: string, isSelect: boolean, queryParams: any, preTab?: any }> = [];
  systemCode: string = "";

  constructor(
    private router: Router, //路由服务
    public message: SwMassageBoxService, //消息提示框
    private jwt: SwJwtService, //浏览器缓存
    private http: SwHttpClientService, //浏览器缓存
    private swLoadingmaskService: SwLoadingmaskService,  //过渡效果
  ) {
    //#region  将路由的根节点的数据写入路由复用上的根节点
    // let routes: { [routePath: string]: RouteStates } = {}
    // //获取所有的在app的主模块
    // router.config[0].children.reduce((a, b) => {
    //   if (b.path !== "") {
    //     a[b.path] = { max: 200, handles: {}, handleKeys: [] };
    //   }
    //   return a;
    // }, routes)
    // SwSimpleReuseStrategy.routes = routes
  }
  //#endregion


  valueUpdated: Subject<any> = new Subject<any>();

  //路由守卫
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //#region
    /**
     * 1.初始化拿到菜单 查看加载的是那个模块
     * 2.每次路由跳转的时候 验证是否有权限，跨模块就跳转
     * 3.权限不够 不让跳转
     */
    //this.menuList = JSON.parse(this.jwt.getToken("TabMenu"));
    let path = "";
    for (let i = 0; route["_urlSegment"].segments.length > i; i++) {
      if (route["_urlSegment"].segments[i].path != "") {
        path = path + "/" + route["_urlSegment"].segments[i].path
      }
    }
    //拆分path,拿到模块信息/bdp/JobQuery
    if (environment["defaultDictionary"] != null) {
      let moduleInfo = path.split("/");
      if (moduleInfo.length > 0) {
        //先转化成大写再操作
        moduleInfo[1]=moduleInfo[1].toLocaleUpperCase();

        if (moduleInfo[1] == "OA" || moduleInfo[1] == "BDP") {
          moduleInfo[1] = "SYS";
        }
        let LoadedDictionaryData=this.jwt.getToken("LoadedDictionary")==null?"":this.jwt.getToken("LoadedDictionary");
        if (LoadedDictionaryData.indexOf(moduleInfo[1]+"|")<0) {
          //从用户的system中取得systemCode
          let userInfo = JSON.parse(this.jwt.getToken("User"));
          let systemId = this.jwt.getToken("systemId");
          this.systemCode = userInfo.systems.filter(x => x.systemId == systemId)[0].systemCode;  //从缓存中得到当前用户system的code信息
         
          let urlBasic=environment.seekerWebAPI;
          //略过，默认加载了
          if(moduleInfo[1]!="SYS"){
            urlBasic=environment[moduleInfo[1].toLocaleLowerCase()+"WebAPI"];
            if(urlBasic){
              this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + this.systemCode,[moduleInfo[1]]).subscribe(data => {
                if (data["code"] == 200) {
                  //先关闭加载层
                  this.swLoadingmaskService.closeLoading();
                  LoadedDictionaryData+=moduleInfo[1]+"|";
                  //已加载过得模块累加进去
                  this.jwt.setToKen("LoadedDictionary", LoadedDictionaryData);
                  let dictionaryData= this.jwt.getToken("dictionary");
                  if(dictionaryData){
                    let dictionary=JSON.parse(dictionaryData);
                    //把新模块的字典项合并进去
                    this.jwt.setToKen("dictionary", JSON.stringify([...dictionary,...data["data"]]));
                  }
                }
              })
            }
          }
        } else {
          this.swLoadingmaskService.closeLoading();
        }
      }
    }

    if (this.menuList == null) {
      this.menuList = [];
    }

    let title = "";
    if (path.split('/').length > 2) {
      //权限验证
      //把上个标签页信息放在此新增的tab页中,如果此标签页参数中有 closeToMain ,表明是第三级标签页，那么它的上级就是改为上级的上级,也就是主页面
      let pre = this.menuList.filter(v => v.isSelect)[0]
      let preActiveTab = {}
      if (route.queryParams['closeToMain']) {
        //在一个打开的tab中再次打开一个tab页
        if (pre && pre['preTab']) {
          preActiveTab['isSelect'] = false
          preActiveTab['path'] = pre['preTab']['path']
          preActiveTab['queryParams'] = JSON.parse(JSON.stringify(pre['preTab']['queryParams']))
        }
      } else {
        //正常情况下打开一个tab页时,如果要跳转的路径和上一个路径是一样的，说明是刷新功能，那么此时，preTab 不需要改变
        if (pre && pre.path && pre.path != path) {
          preActiveTab['isSelect'] = false
          preActiveTab['path'] = pre.path
          preActiveTab['queryParams'] = JSON.parse(JSON.stringify(pre.queryParams))
        } else if(pre && pre.path && pre.path == path && pre['preTab']){
          //此时是刷新当前页面,就是从a->a，那么刷新时，后一个 a 的 preTab 要和前一个 a 的 preTab 一样，否则单页签时关闭 a 的时候，会跳转到自身
          preActiveTab = JSON.parse(JSON.stringify(pre['preTab']))
        }
      }
      //将之前的tab菜单的选中状态全都变为不选中
      this.menuList.forEach(p => p.isSelect = false);
      var menu = { path: path, isSelect: true, queryParams: route.queryParams };
      let exitMenu = this.menuList.find(info => (info.path == path));
      if (exitMenu) {//如果存在不添加，当前表示选中
        //判断路由的路径 和参数是否一致
        if ((exitMenu.path == path && JSON.stringify(exitMenu.queryParams) == JSON.stringify(route.queryParams)) || exitMenu.queryParams.Title == "控制台" || exitMenu.queryParams.Title == "Job Portal") {
          //如果一致选中
          // this.menuList.forEach(p => p.isSelect = (p.path == path));
          this.menuList.forEach(p => {
            if (p.path == path) {
              p.isSelect = true
              delete p.preTab
              if(Object.keys(preActiveTab).length){
                p.preTab = JSON.parse(JSON.stringify(preActiveTab))  //修改当前标签的上个标签
              }
            } else {
              p.isSelect = false
            }
          })
        } else {
          //如果不一致重新加载路由
          //删除路由复用
          SwSimpleReuseStrategy.deleteRouteSnapshot(path)
          this.menuList.forEach(dt => {
            if (dt.path == path) {
              dt.queryParams = route.queryParams;
              dt.isSelect = true;
              delete dt.preTab
              if(Object.keys(preActiveTab).length){
                dt.preTab = JSON.parse(JSON.stringify(preActiveTab))  //修改当前标签的上个标签
              }
            }
          })
        }
      } else {

        //判断当前tab页的数量 ，数量限制不超过10个  打开页面过多，会影响页面性能，
        if (this.menuList.length > environment.tabNumber) {
          this.message.danger("打开窗口过多，会影响用户体验!")
          // return false;
        }
        if (this.menuList.length > 0) {
          //第一次加载,只加载工作台
          if(Object.keys(preActiveTab).length){
            menu['preTab'] = preActiveTab
          }
          this.menuList.push(menu);
        } else {
          SwSimpleReuseStrategy.deleteRouteSnapshot(path)
          if(Object.keys(preActiveTab).length){
            menu['preTab'] = preActiveTab
          }
          this.menuList.push(menu);
          //删除路由复用
          /////SwSimpleReuseStrategy.deleteRouteSnapshot(path) 
        }
      }
      // console.log(this.menuList);

      this.valueUpdated.next(this.menuList);
      //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));
    }
    //#endregion
    //判断如果是跨模块的访问路径地址
    //修改菜单信息


    //判断如果是跨模块的访问路径地址
    //修改菜单信息
    if (state.url == "#") {
      return false;
    }

    return true;
  }

  getMenus(): any {
    return this.menuList;
  }

  clear() {
    this.menuList = [];
  }

  setMenu(menuList: any) {
    this.menuList = menuList;
  }


  //加载模块的工作台
  setMenus(menu: any, isTab?: Number): any {
    //判断有没有工作台
    let Tab = []
    if (this.menuList != null) {
      Tab = this.menuList.filter(x => x.queryParams.Title == "控制台" || x.queryParams.Title == "Job Portal")
    } else {
      this.menuList = [];
    }
    if (Tab.length > 0) {
      //如果是 关闭过渡层
      if (this.menuList[0].path.toLowerCase() == menu.path.toLowerCase()) {
        this.swLoadingmaskService.closeLoading();
      }
      //如果有工作台 判断加载是不是当前的工作台
      this.menuList[0].path = menu.path
    } else {
      //否则新增tab 
      /////this.menuList.push(menu)  
      this.menuList.unshift(menu)
    }
    //发布tab猜的那
    this.valueUpdated.next(this.menuList);
    //将tab 写入浏览器缓存
    //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));
    //请求 地址 
    let list = this.menuList.filter(item => item.isSelect == true)[0]
    this.router.navigate([list.path], {
      queryParams: list.queryParams
    });
  }
}
